import React, { useState } from 'react';
import _isEmpty from 'lodash.isempty';
import memoizeOne from 'memoize-one';
import { Dropdown, Text } from '../../../../../../../ui-kit';








const TeamCredits = (props) => {
  const { teamCreditInfo, creditType, onSelectTeam, isSaveDisabled } = props;
  const getTeamCreditsOptions = memoizeOne(() => teamCreditInfo.map(({ team }) => ({
    label: team.name,
    value: team.teamId,
    suffix: team.creditBalance && creditType === 'TEAM' ?
    <b>{`${team.creditBalance.balance + team.creditBalance.rolloverBalance} Credits Available`}</b> : null
  }))
  );
  const options = getTeamCreditsOptions();

  const [teamCreditValue, setTeamCreditValue] = useState(options[0]);

  const onChange = (value) => {
    setTeamCreditValue(value);
    onSelectTeam(value);
  };

  return (
    <>
      {!_isEmpty(options) &&
      <Dropdown
        type="BUTTON"
        options={options}
        onChange={onChange}
        defaultValue={teamCreditValue || options[0]}
        label="Select the team you want to submit this Project under"
        labelProps={{ required: true }}
        fontSize={12}
        showSelectedSuffix={creditType === 'TEAM'}
        disabled={teamCreditInfo.length === 1} />}


      {!_isEmpty(options) && isSaveDisabled ?

      <Text className="addons-payment__foot-note" danger>
            Please contact your Workspace Admin to allocate or purchase more Video Credits
            for your team.
          </Text> :
      null}
    </>);

};

export default TeamCredits;